import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CustomHttp } from '@service/customhttp.service';
import { RequestLibraryService } from '@service/core/request-library.service';
import 'rxjs/add/operator/map';
import { HttpClient } from '@angular/common/http';
@Injectable()
export class WebhookService {
    private customHttp: CustomHttp;
    constructor(
        private http: HttpClient,
        private router: Router,
        private requestLibrary: RequestLibraryService
    ) {
        this.customHttp = new CustomHttp(http, router);
    }
    getPaginatedWebHooks(page, page_size, sort, sort_dir) {
        return this.requestLibrary.GetAll('/webhooks', {
            'options': { page: page, page_size: page_size, sort: sort, sort_dir: sort_dir }
        });
    }

    getExportedWebHooks(args) {
        return this.requestLibrary.GetCSV('/webhooks', {
            'options': args
        });
    }

    getAllWebhooks() {
        return this.requestLibrary.Get('/webhooks');
        // return this.customHttp.getAll('/webhooks?options=', { page_size: 'all' });
    }


    getWebHook(id) {
        return this.requestLibrary.Get(`/webhooks/${id}`);
    }

    addEditWebHook(model) {
        return this.requestLibrary.Post('/webhooks', model);
    }

    deleteWebHook(id) {
        return this.requestLibrary.Delete(`/webhooks/${id}`);
    }

}
